<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Imunização"
            description="Vacinas por vacinados"
            url="/dashboard"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img
                v-else-if="item.imagem !== ''"
                :src="item.imagem !== '' ? item.imagem : ''"
                alt=""
              />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import ImportarVacinas from '@/components/icons/Imunizacao/ImportarVacinas.vue'

export default {
  name: 'Imunizacao',
  metaInfo: {
    title: 'Imunização',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    ImportarVacinas,
  },
  computed: {
    cards() {
      if (
        this.$store.state &&
        this.$store.state.permissoes &&
        this.$store.state.permissoes.imunizacao
      ) {
        const dataClone = [...this.$store.state.permissoes.imunizacao]
        return dataClone.sort((a, b) => a.ordem - b.ordem)
      }
      return []
    },
  },
  data() {
    return {}
  },
}
</script>

<style></style>
